export default "__VITE_ASSET__b32a8daf__"